import React from "react";
import { Link } from "react-router-dom";
import "../css/main.css";

import trip_1 from "../public/trip/trip_1.png";
import hero_1 from "../public/hero/hero_1.png";
import mountains_ranges from "../public/mountains-ranges/mountains-ranges.png";

import { useContext } from "react";
import { DarkModeContext } from "../components/DarkModeProvider";

const Home = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? "hero dark" : "hero light"}>
        <div className="container">
          <div className=" hero-container">
            <div className="hero-content">
              <div className="hero-box">
                <h1 className={darkMode ? "dark-text" : "light-text"}>České</h1>
                <h1 className={darkMode ? "dark-text" : ""}>Pohoří</h1>
              </div>
            </div>
            <div className="hero-image">
              <img src={hero_1} alt="Hero illustration" />
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "trip dark" : "trip light"}>
        <div className="container">
          <div className="trip-container">
            <div className="trip-image">
              <img src={trip_1} alt="Trip illustration" />
            </div>
            <div className="trip-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Tipy na výlety v Česku
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                I když si to možná neuvědomujeme, tak i Česko dokáže nabídnout
                spoustu nádherných lokalit kam se vydat a nemusíme cestovat ani
                daleko. Stačí se jen porozhlédnout, sbalit si věci a vyrazit
                objevovat. Proto neváhej se dozvědět více info. Stačí kliknout na tlačítko níže 
                a poté si vybrat svou destinaci, kterou chceš objevovat.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/tipynavylety"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "mountains-ranges dark" : "mountains-ranges light"
        }
      >
        <div className="container">
          <h2 className={darkMode ? "dark-text" : "light-text"}>
            Poznejte nová místa!
          </h2>
          <div className="mountains-ranges-container">
            <div className="mountains-ranges-content">
              <Link to="/beskydy" className={darkMode ? 'mountains-ranges-columns dark-box ' : 'mountains-ranges-columns light-box'}>
                <h3 className={darkMode ? 'light-text' : 'dark-text'}>Beskydy</h3>
                <p className={darkMode ? 'light-second-text' : ''}>Mimo nádherné hory, zde můžete podniknout zajímavé aktivity</p>
              </Link>

              <Link to="/jeseniky" className={darkMode ? 'mountains-ranges-columns dark-box ' : 'mountains-ranges-columns light-box'}>
                <h3 className={darkMode ? 'light-text' : 'dark-text'}>Jeseníky</h3>
                <p className={darkMode ? 'light-second-text' : ''}>Je zde spoustu lázeňských měst a míst kde můžete odpočívat</p>
              </Link>

              <Link to="/krkonose" className={darkMode ? 'mountains-ranges-columns dark-box ' : 'mountains-ranges-columns light-box'}>
                <h3 className={darkMode ? 'light-text' : 'dark-text'}>Krkonoše</h3>
                <p className={darkMode ? 'light-second-text' : ''}>Nabídnou vám dechberoucí hory</p>
              </Link>

              <Link to="/sumava" className={darkMode ? 'mountains-ranges-columns dark-box ' : 'mountains-ranges-columns light-box'}>
                <h3 className={darkMode ? 'light-text' : 'dark-text'}>Šumava</h3>
                <p className={darkMode ? 'light-second-text' : ''}>Najdete zde okouzlující přírodu a také spoustu památek </p>
              </Link>
            </div>
            <div className="mountains-ranges-image">
              <img src={mountains_ranges} alt="" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
